import React from "react";

export function OverallSummary({ items = [] }) {
  return (
    <section className="lw-overall" aria-label="Overall view" data-edit-name="Overall view">
      <div className="lw-overall__label">
        <span className="lw-kicker">Overall view</span>
        <strong>What needs attention</strong>
      </div>
      <div className="lw-overall__metrics">
        {items.map((item) => (
          <article className={`lw-metric lw-tone--${item.tone || "neutral"}`} key={item.id}>
            <span>{item.label}</span>
            <strong>{item.value}</strong>
            {Number.isFinite(item.progress) ? (
              <span
                className="lw-progress"
                role="progressbar"
                aria-label={item.label}
                aria-valuemin="0"
                aria-valuemax="100"
                aria-valuenow={item.progress}
              >
                <span style={{ width: `${item.progress}%` }} />
              </span>
            ) : null}
          </article>
        ))}
      </div>
    </section>
  );
}
